
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/noResults';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<p>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.no_results")
  },data:data},helper ? helper.call(depth0, "discussions.no_results.your_search_did_not_match_any_entries", "Your search did not match any entries.", options) : helperMissing.call(depth0, "t", "discussions.no_results.your_search_did_not_match_any_entries", "Your search did not match any entries.", options)))
    + "\n</p>\n<p>\n"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.no_results")
  },data:data},helper ? helper.call(depth0, "discussions.no_results.suggestions", "Suggestions:", options) : helperMissing.call(depth0, "t", "discussions.no_results.suggestions", "Suggestions:", options)))
    + "\n<ul>\n  <li>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.no_results")
  },data:data},helper ? helper.call(depth0, "discussions.no_results.make_sure_all_search_terms_are_spelled_correctly", "Make sure all search terms are spelled correctly.", options) : helperMissing.call(depth0, "t", "discussions.no_results.make_sure_all_search_terms_are_spelled_correctly", "Make sure all search terms are spelled correctly.", options)))
    + "</li>\n  <li>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.no_results")
  },data:data},helper ? helper.call(depth0, "discussions.no_results.try_different_more_general_or_fewer_keywords", "Try different, more general, or fewer keywords.", options) : helperMissing.call(depth0, "t", "discussions.no_results.try_different_more_general_or_fewer_keywords", "Try different, more general, or fewer keywords.", options)))
    + "</li>\n  <li>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.no_results")
  },data:data},helper ? helper.call(depth0, "discussions.no_results.try_disabling_the_unread_filter", "Try disabling the \"Unread\" filter.", options) : helperMissing.call(depth0, "t", "discussions.no_results.try_disabling_the_unread_filter", "Try disabling the \"Unread\" filter.", options)))
    + "</li>\n</ul>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  